type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'purple'

const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-gray-100 text-gray-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-amber-100 text-amber-700',
  danger: 'bg-red-100 text-red-700',
  info: 'bg-blue-100 text-blue-700',
  purple: 'bg-purple-100 text-purple-700',
}

export default function Badge({ children, variant = 'default' }: { children: React.ReactNode; variant?: BadgeVariant }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${variantStyles[variant]}`}>
      {children}
    </span>
  )
}

export function StageBadge({ stage }: { stage: string }) {
  const stageMap: Record<string, BadgeVariant> = {
    new: 'info',
    contacted: 'default',
    qualified: 'purple',
    demo_scheduled: 'warning',
    proposal_sent: 'warning',
    negotiation: 'purple',
    won: 'success',
    lost: 'danger',
  }
  return <Badge variant={stageMap[stage] || 'default'}>{stage.replace('_', ' ')}</Badge>
}

export function SegmentBadge({ segment }: { segment: string | null }) {
  if (!segment) return null
  const map: Record<string, BadgeVariant> = { HOT: 'danger', WARM: 'warning', COLD: 'info' }
  return <Badge variant={map[segment] || 'default'}>{segment}</Badge>
}

export function PriorityBadge({ priority }: { priority: string }) {
  const map: Record<string, BadgeVariant> = { urgent: 'danger', high: 'warning', medium: 'default', low: 'info' }
  return <Badge variant={map[priority] || 'default'}>{priority}</Badge>
}

export function StatusBadge({ status }: { status: string }) {
  const map: Record<string, BadgeVariant> = {
    pending: 'warning', completed: 'success', overdue: 'danger', cancelled: 'default',
    sent: 'success', delivered: 'success', bounced: 'danger', failed: 'danger', queued: 'default',
    initiated: 'info', ringing: 'warning', in_progress: 'purple', busy: 'danger', no_answer: 'warning',
    answered: 'info', connected: 'success', interacted: 'purple', voicemail: 'warning',
  }
  return <Badge variant={map[status] || 'default'}>{status.replace('_', ' ')}</Badge>
}
